"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Icons = void 0;

var _service = require("../service");

var _helpers = require("../../util/helpers");

var _presets = _interopRequireDefault(require("./presets"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Icons =
/*#__PURE__*/
function (_Service) {
  _inherits(Icons, _Service);

  function Icons(preset) {
    var _this;

    _classCallCheck(this, Icons);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Icons).call(this));
    var _preset$Icons$propert = preset[Icons.property],
        iconfont = _preset$Icons$propert.iconfont,
        values = _preset$Icons$propert.values;
    _this.iconfont = iconfont;
    _this.values = (0, _helpers.mergeDeep)(_presets.default[iconfont], values);
    return _this;
  }

  return Icons;
}(_service.Service);

exports.Icons = Icons;
Icons.property = 'icons';
//# sourceMappingURL=index.js.map